export default "__VITE_ASSET__DYICki6___"